export default "__VITE_ASSET__BrrabjFD__"